import React from "react";
import { BrowserRouter } from "react-router-dom";
import RoutesApp from "./routes/routes";
import { useAuth } from "./hooks/useAuth";
import { ErrorBoundary } from "./components/ErrorBoundary/ErrorBoundary";
import { TelemetryRouteTracker } from "./components/telemetry/TelemetryRouteTracker";

const App = () => {
  const { loadingAuth } = useAuth();

  if (loadingAuth) return null;

  return (
    <ErrorBoundary>
      <BrowserRouter
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        {/* usage-event-pipeline (task 4.9): D6 warehouse events. */}
        <TelemetryRouteTracker />
        <RoutesApp />
      </BrowserRouter>
    </ErrorBoundary>
  );
};

export default App;
